import React, { Component } from 'react';
import { Container, Button, Form, FormGroup, Input, FormFeedback, Row, Col, Card, CardBody, CardLink, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import Tarjeta from '../../Componentes/Cards/estudianteCard'
import validaciones from '../../Auxiliares/validaciones'

export default class AdminDocs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estudiantes: [],
            noControl: '',
            nombre: '',
            ap_paterno: '',
            ap_materno: '',
            semestre: '1',
            carrera: 'Ing. en Sistemas Computacionales',
            errors: {},
            Errormsg: '',
            isAddModalOpen: false,
        }
        this.toggleAdd = this.toggleAdd.bind(this)
        this.registrar = this.registrar.bind(this)
        this.actualizarLista = this.actualizarLista.bind(this)
    }

    componentDidMount() {
        this.actualizarLista();
    }

    actualizarLista() {
        Fetch('/api/tmp/getEstudiantes', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({ estudiantes: response.data })
            })
            .catch(err => {
                switch (err.status) {
                    case 602:
                        toast.error('No existen datos correspondientes')
                        break;
                    case 605:
                        toast.info('Lista vacia')
                        this.setState({ estudiantes: [] })
                        break;
                    default:
                        toast.error(err)
                        break;
                }
            })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                case 'noControl':
                    if (validaciones.validar_noControl(this.state.noControl)) {
                        value = validaciones.validar_noControl(this.state.noControl)
                        this.setState(prevState => ({ errors: { ...prevState.errors, noControl: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).noControl) });
                    }
                    break;

                case 'nombre':
                    if (validaciones.validar_nombre(this.state.nombre)) {
                        value = validaciones.validar_nombre(this.state.nombre)
                        this.setState(prevState => ({ errors: { ...prevState.errors, nombre: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).nombre) });
                    }
                    break;

                case 'ap_paterno':
                    if (validaciones.validar_ap_paterno(this.state.ap_paterno)) {
                        value = validaciones.validar_ap_paterno(this.state.ap_paterno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_paterno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_paterno) });
                    }
                    break;

                case 'ap_materno':
                    if (validaciones.validar_ap_materno(this.state.ap_materno)) {
                        value = validaciones.validar_ap_materno(this.state.ap_materno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_materno: value } }));
                    } else {
                        this.setState({errors: (delete Array.from(this.state.errors).ap_materno) });
                    }
                    break;
                
                default:
                    break;
            }
        })
    }

    toggleAdd() {
        this.setState(prevState => ({
            isAddModalOpen: !prevState.isAddModalOpen,
            errors: {}
        }));
    }

    registrar() {
        const { noControl, nombre, ap_paterno, ap_materno, carrera, semestre } = this.state
        
        if (validaciones.sinErrores(this.state.errors)) {
            Fetch('/api/tmp/addEstudiante', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ noControl, nombre, ap_paterno, ap_materno, carrera, semestre })
            })
                .then(response => {
                    this.actualizarLista();
                    this.toggleAdd();
                })
                .catch(err => {
                    switch (err.status) {
                        case 600:
                            this.setState({ Errormsg: 'Se ha perdido la conexion' })
                            break;
                        case 601:
                            this.setState(prevState => ({ errors: { ...prevState.errors, noControl: 'Este numero de control ya esta registrado' } }))
                            break;
                        case 604:
                            this.setState({ Errormsg: 'Error inesperado' })
                            break;

                        default:
                            toast.error(err)
                            break;
                    }
                })
        }
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light col-sm-2">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>
                                    <Card className="mt-3 p-4" >
                                        <h1 className="display-4">Estudiantes</h1>
                                        <p className="lead">Esta seccion permite agregar, modificar o eliminar estudiantes</p>
                                        <hr className="my-1" />
                                    </Card>

                                    <Row>
                                        <Col className="p-3 text-right col-12">
                                            <Button className="p-3 w-25 float-right bg-light text-dark" onClick={() => this.toggleAdd()}>Agregar</Button>
                                        </Col>

                                        <Tarjeta encabezado={true} />
                                        {this.state.estudiantes.length > 0 ? this.state.estudiantes.map((index) => (<Tarjeta id={index._id} noControl={index.noControl} nombre={index.nombre} ap_paterno={index.ap_paterno} ap_materno={index.ap_materno} carrera={index.carrera} semestre={index.semestre} actualizar={this.actualizarLista} />)) : <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >Lista vacia</Card></Col>}

                                    </Row>
                                </Container>
                            </div>
                        </div>
                    </Col>
                    {/*Modal */}
                    <Modal isOpen={this.state.isAddModalOpen} toggle={() => this.toggleAdd()}
                        className="modal-md">
                        <ModalHeader toggle={() => this.toggleAdd()}>Agregar estudiante</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col>
                                    <Card className="p-3">
                                        <Container>
                                            {this.state.Errormsg !== '' ? <Alert color="danger">{this.state.Errormsg}</Alert> : <div></div>}
                                            <Form className="mx-5 mt-5">
                                                <Row style={{ display: 'flex', justifyContent: 'center', height: '100%' }} className="mb-4" >
                                                    <Col>
                                                        <Form className="register-form" method="post" encType="multipart/form-data" onSubmit={this.registrar}>
                                                            <FormGroup>
                                                                <Input type="text" className="w-100" onChange={this.setValue.bind(this, "noControl")} invalid={this.state.errors.noControl} placeholder="No. Control" name="noControl" maxLength="8" />
                                                                <FormFeedback>{this.state.errors.noControl}</FormFeedback>
                                                            </FormGroup>

                                                            <FormGroup>
                                                                <Input type="text" className="w-100" onChange={this.setValue.bind(this, "nombre")} invalid={this.state.errors.nombre} placeholder="Nombre" name="Nombre" />
                                                                <FormFeedback>{this.state.errors.nombre}</FormFeedback>
                                                            </FormGroup>

                                                            <FormGroup>
                                                                <Input type="text" className="w-100" onChange={this.setValue.bind(this, "ap_paterno")} invalid={this.state.errors.ap_paterno} placeholder="Apellido Paterno" name="ap_paterno" />
                                                                <FormFeedback>{this.state.errors.ap_paterno}</FormFeedback>
                                                            </FormGroup>

                                                            <FormGroup>
                                                                <Input type="text" className="w-100" onChange={this.setValue.bind(this, "ap_materno")} invalid={this.state.errors.ap_materno} placeholder="Apellido Materno" name="ap_materno" />
                                                                <FormFeedback>{this.state.errors.ap_materno}</FormFeedback>
                                                            </FormGroup>

                                                            <FormGroup>
                                                                <Input type="select" name="carrera" onChange={this.setValue.bind(this, "carrera")} className="w-100" >
                                                                    <option>Ing. en Sistemas Computacionales</option>
                                                                    <option>Ing. Industrial</option>
                                                                    <option>Ing. en Logistica</option>
                                                                    <option>Ing. en Mecatronica</option>
                                                                    <option>Ing. en Mecánica</option>
                                                                    <option>Ing. en Gestion</option>
                                                                    <option>Ing. en Energias Renovables</option>
                                                                    <option>Ing. en Electronica</option>
                                                                    <option>Ing. en Quimica</option>
                                                                    <option>Ing. en Eléctrica</option>
                                                                    <option>Lic. en Contabilidad</option>
                                                                </Input>
                                                            </FormGroup>

                                                            <FormGroup>
                                                                <Input type="select" name="semestre" onChange={this.setValue.bind(this, "semestre")}>
                                                                    <option>1</option>
                                                                    <option>2</option>
                                                                    <option>3</option>
                                                                    <option>4</option>
                                                                    <option>5</option>
                                                                    <option>6</option>
                                                                    <option>7</option>
                                                                    <option>8</option>
                                                                    <option>9</option>
                                                                    <option>10</option>
                                                                    <option>11</option>
                                                                    <option>12</option>
                                                                </Input>
                                                            </FormGroup>
                                                        </Form>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Container>

                                        <CardBody className="text-center">
                                            <CardLink><Button className="btn-info" onClick={() => this.registrar()}>Crear</Button></CardLink>
                                            <CardLink><Button className="btn-light" onClick={() => this.toggleAdd()}>Cancelar</Button></CardLink>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                </Row>
                <Footer />
            </html>
        )
    }
}
